const user = {
  headerMapping: {
    Name: 'name',
    Email: 'email',
    Role: 'role',
    Phone: 'mobile_no',
    'User Permission(Default - BOTH)': 'notification_permission',
  },
  exportAndRejectionHeaders: {
    'Name*': 'name',
    'Email*': 'email',
    'Role*': 'role',
    Phone: 'mobile',
    'User Permission(Default - BOTH)': 'notification_permission',
  },
  validationErrorMessage: {
    EMAIL: 'Invalid email id',
    ROLE: 'Invalid role',
    DUPLICATE: 'Email already exists in Pando. Please provide an alternate email',
    EMAIL_NOT_EXIST: 'Not a valid email',
    STATUS: 'Not a valid status',
  },
};

module.exports = { user };
